/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { UpdateCompositionsDetailMutationRequest, UpdateCompositionsDetailMutationResponse, UpdateCompositionsDetailPathParams } from "../models/UpdateCompositionsDetail";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { updateCompositionsDetail } from "../axios/updateCompositionsDetail";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const updateCompositionsDetailMutationKey = () => ["web-app-bff-api", { url: '/compositions/:id' }] as const

export type UpdateCompositionsDetailMutationKey = ReturnType<typeof updateCompositionsDetailMutationKey>

export function updateCompositionsDetailMutationOptions<TContext = unknown>(config: Partial<RequestConfig<UpdateCompositionsDetailMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = updateCompositionsDetailMutationKey()
        return mutationOptions<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ id, data }) => {
            return updateCompositionsDetail(id, data, config)
          },
        })

}

/**
 * @summary Update a composition by id
 * {@link /compositions/:id}
 */
export function useUpdateCompositionsDetail<TContext>(options: 
{
  mutation?: UseMutationOptions<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<UpdateCompositionsDetailMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? updateCompositionsDetailMutationKey()

          const baseOptions = updateCompositionsDetailMutationOptions(config) as UseMutationOptions<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest}, TContext>
          

          return useMutation<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<UpdateCompositionsDetailMutationResponse, ResponseErrorConfig<Error>, {id: UpdateCompositionsDetailPathParams["id"], data: UpdateCompositionsDetailMutationRequest}, TContext>
      
}